import { connect } from 'react-redux';

import PausedStatusActions from './component';

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(PausedStatusActions);
